import {ExternalLink, KeyRound, Receipt, TrendingUp, Users} from 'lucide-react';
import {Alert, CircularProgress} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {PortalShell} from '../../shared/ui';
import {useAuth} from '../../shared/auth/AuthContext';
import {usePortalDashboard} from './usePortalDashboard';

const iconByKpi = {
    licencas: KeyRound,
    usuarios: Users,
    faturas: Receipt,
};

export default function PortalDashboardPage() {
    const navigate = useNavigate();
    const {userLogged} = useAuth();
    const data = usePortalDashboard();
    const currentHour = new Date().getHours();
    const greeting = currentHour < 12 ? 'Bom dia' : currentHour < 18 ? 'Boa tarde' : 'Boa noite';

    return (
        <PortalShell>
            <div className="bf-page">
                <div>
                    <h1 className="bf-page__title">{greeting}, {userLogged?.name || 'Cliente'} 👋</h1>
                    <p className="bf-page__subtitle">Aqui está um resumo da sua operação hoje.</p>
                </div>

                {data.error ? <Alert severity="warning">{data.error}</Alert> : null}

                {data.loading ? (
                    <div className="bf-empty"><CircularProgress /></div>
                ) : (
                    <>
                        <div className="bf-grid-3">
                            {data.metrics.slice(0, 3).map((kpi, index) => {
                                const Icon = iconByKpi[kpi.id] || KeyRound;
                                return (
                                    <div key={kpi.id} className="bf-card bf-card--hover">
                                        <div className="bf-card__body">
                                            <div className="bf-row-between" style={{alignItems: 'flex-start', marginBottom: 16}}>
                                                <div className="bf-kpi-icon"><Icon size={24} /></div>
                                                {index < 2 ? <TrendingUp size={16} color="#10b981" /> : null}
                                            </div>
                                            <div className="bf-kpi-value">{kpi.value}</div>
                                            <div className="bf-kpi-title">{kpi.title}</div>
                                            <div className="bf-kpi-change">{kpi.detail}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div>
                            <div className="bf-section-head">
                                <h2 className="bf-section-title">Sistemas</h2>
                                <button className="bf-button bf-button--secondary bf-button--sm" onClick={() => navigate('/sistemas')}>Ver todos</button>
                            </div>

                            <div className="bf-grid-3">
                                {data.systems.map((system) => (
                                    <div key={system.id} className="bf-card bf-card--hover">
                                        <div className="bf-card__header">
                                            <div className="bf-row-between" style={{alignItems: 'flex-start', marginBottom: 8}}>
                                                <div>
                                                    <h3 className="bf-system-title">{system.name}</h3>
                                                    <p className="bf-system-desc">{system.category}</p>
                                                </div>
                                                <span className="bf-badge bf-badge--success-soft">online</span>
                                            </div>
                                        </div>
                                        <div className="bf-card__body" style={{paddingTop: 16}}>
                                            <div className="bf-stack-2">
                                                <div className="bf-row-between" style={{fontSize: 14}}>
                                                    <span className="bf-muted">Módulos ativos</span>
                                                    <span style={{fontWeight: 500}}>{system.modules}</span>
                                                </div>
                                                <div className="bf-row-between" style={{fontSize: 14}}>
                                                    <span className="bf-muted">Versão</span>
                                                    <span style={{fontWeight: 500}}>{system.version || '-'}</span>
                                                </div>
                                                <button className="bf-button bf-button--primary bf-button--sm bf-button--full" onClick={() => navigate('/licencas')}>
                                                    <span>Acessar Sistema</span>
                                                    <ExternalLink size={14} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </PortalShell>
    );
}
